import React, { useEffect, useState } from 'react'
import { fetchInstructorCourses } from '../../../services/operations/courseDetailsAPI'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { VscAdd } from "react-icons/vsc"
import IconBtn from '../../common/IconBtn';
import CoursesTable from './InstructorCourses/CoursesTable';

const MyCourses = () => {

    const [courses,setCourses] = useState([]);
    const {token} = useSelector((state)=>state.auth);
    const navigate = useNavigate();

    const fetchCourses = async()=>{
        try {
            const response = await fetchInstructorCourses(token);
            console.log("response of courses", response);
            setCourses(response);
        } catch (error) {
            console.log(" failed to fetch courses");
            console.log(courses);
        }
        
    }

    useEffect(()=>{
        fetchCourses();
    },[]);
  return (
    <div>
      <div className="mb-14 flex items-center justify-between">
        <h1 className="text-3xl font-medium text-richblack-5">My Courses</h1>
        <IconBtn
          text="Add Course"
          onclick={() => navigate("/dashboard/add-course")}
        >
          <VscAdd />
        </IconBtn>
      </div>
      {courses && <CoursesTable courses={courses} setCourses={setCourses} />}
    </div>
  )
}

export default MyCourses